document.addEventListener('DOMContentLoaded', () => {
  initDiscoverWork();
});

document.addEventListener('shopify:section:load', () => {
  initDiscoverWork();
});

function initDiscoverWork() {
  if (typeof window.discoverWorkData === 'undefined') return;
  const data = window.discoverWorkData;

  // Vertical sequence (work)
  initImageSequence({
    imgSelector: 'js-work-sequence-img',
    sliderSelector: '.js-work-slider',
    nextButtonSelector: '.js-work-slider-button-next',
    hotspotSelector: '.js-work-hotspot',
    images: data.images,
    pointsPositions: data.pointsPositions
  });

  // Horizontal sequence (design) - If required:
  initImageSequence({
    imgSelector: 'js-design-sequence-img',
    sliderSelector: '.js-design-slider',
    nextButtonSelector: '.js-design-slider-button-next',
    hotspotSelector: '.js-design-hotspot',
    images: data.designImages,
    pointsPositions: data.designPointsPositions
  });
}

function initImageSequence(options) {
  const { imgSelector, images, pointsPositions, hotspotSelector, nextButtonSelector, sliderSelector } = options;
  const imgElement = document.getElementById(imgSelector);
  if (!imgElement) return;

  let currentIndex = 0;
  let currentSequence = [];
  let sequenceTween;
  let isReversing = false;
  let activeSequenceId = null;

  const allImages = Object.values(images).flat();
  preloadImages(allImages);

  function preloadImages(imageArray) {
    imageArray.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }

  function updateImage(reverse = false) {
    if (reverse) {
      currentIndex--;
      if (currentIndex < 0) {
        sequenceTween.kill();
        isReversing = false;
        currentIndex = 0;
        imgElement.src = currentSequence[0];
        return;
      }
    } else {
      currentIndex++;
      if (currentIndex >= currentSequence.length) {
        currentIndex = currentSequence.length - 1;
        sequenceTween.kill();
        imgElement.src = currentSequence[currentIndex];
        return;
      }
    }
    imgElement.src = currentSequence[currentIndex];
  }

  function playSequence(sequence, reverse = false) {
    currentSequence = sequence;
    if (reverse) {
      currentIndex = currentSequence.length - 1;
      isReversing = true;
    } else {
      currentIndex = 0;
      isReversing = false;
    }
    if (sequenceTween) sequenceTween.kill();

    sequenceTween = gsap.to({}, {
      duration: 0.1,
      repeat: reverse ? currentIndex : currentSequence.length - 1,
      onRepeat: () => updateImage(isReversing),
      onComplete: () => {
        if (!reverse) {
          imgElement.src = currentSequence[currentIndex];
        }
        sequenceTween.kill();
      }
    });
    if (reverse) updateImage(true);
  }

  function goToSequence(sequenceId) {
    if (!images.hasOwnProperty(sequenceId)) return;
    const selectedSequence = images[sequenceId];
    if (activeSequenceId === sequenceId) return;

    if (sequenceTween && currentSequence !== selectedSequence) {
      playSequence(currentSequence, true);
      setTimeout(() => {
        playSequence(selectedSequence, false);
        activeSequenceId = sequenceId;
      }, currentSequence.length * 100)
    } else {
      playSequence(selectedSequence, false);
      activeSequenceId = sequenceId;
    }
    movePoints(sequenceId);
  }

  function movePoints(activeId = 0) {
    const hotspots = document.querySelectorAll(hotspotSelector);
    hotspots.forEach(hs => hs.classList.add('is-hidden'));

    setTimeout(() => {
      const activePositions = pointsPositions[activeId];
      Object.keys(activePositions).forEach(key => {
        const hs = document.querySelector(hotspotSelector + '[data-id="' + key + '"]');
        if (hs) {
          hs.style.left = activePositions[key][0] + '%';
          hs.style.top = activePositions[key][1] + '%';
        }
      });
    }, 120);

    setTimeout(() => {
      hotspots.forEach(hs => hs.classList.remove('is-hidden'));
      const nextBtn = document.querySelector(nextButtonSelector);
      if (nextBtn) nextBtn.classList.remove('is-disabled');
    }, 1000);
  }

  // Initialize first sequence
  const initialSequenceId = Object.keys(images)[0];
  const initialSequence = images[initialSequenceId];
  imgElement.src = initialSequence[0];
  currentSequence = initialSequence;
  activeSequenceId = initialSequenceId;
  playSequence(initialSequence, false);
  movePoints(initialSequenceId);

  const swiperEl = document.querySelector(sliderSelector);
  if (!swiperEl) return;

  const nextBtn = document.querySelector(nextButtonSelector);
  if (nextBtn) nextBtn.classList.add('is-disabled');

  const sequenceSlider = new Swiper(swiperEl, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    watchOverflow: true,
    draggable: true,
    speed: 400,
    pagination: false,
    navigation: {
      nextEl: nextButtonSelector,
    }
  });

  sequenceSlider.on('slideChangeTransitionStart', function(swiper) {
    const dataId = swiper.realIndex;
    setTimeout(() => {
      const hotspots = document.querySelectorAll(hotspotSelector);
      hotspots.forEach(hs => hs.classList.remove('is-active'));
      const activeHs = document.querySelector(hotspotSelector + '[data-id="'+ dataId +'"]');
      if (activeHs) activeHs.classList.add('is-active');
    }, 120);
    if (nextBtn) nextBtn.classList.add('is-disabled');
    goToSequence(dataId);
  });

  const hotspots = document.querySelectorAll(hotspotSelector);
  hotspots.forEach(hs => {
    hs.addEventListener('click', () => {
      const dataId = hs.getAttribute('data-id');
      sequenceSlider.slideToLoop(parseInt(dataId, 10));
    });
  });
}
